import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from './lib/sentry';
import './lib/supabase';
import './tokens.css';
import './global.css';

// Sentry first — before any React render or Supabase call so init-time
// errors land in the right project. No-op if VITE_SENTRY_DSN unset.
initSentry();
import { Background } from './components/Background';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { CalibrationProvider } from './contexts/CalibrationContext';
import { BrainBarProvider } from './contexts/BrainBarContext';
import { AuthGate } from './components/AuthGate';
import { OnboardingGate } from './components/OnboardingGate';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Background />
      <BrowserRouter>
        <AuthProvider>
          <AuthGate>
            <CalibrationProvider>
              <BrainBarProvider>
                <OnboardingGate>
                  <App />
                </OnboardingGate>
              </BrainBarProvider>
            </CalibrationProvider>
          </AuthGate>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
